module.exports = __webpack_public_path__ + "static/media/mx-start.e89b708b.png";